
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsandconditions",
      function () {
        return require("private-next-pages/termsandconditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsandconditions"])
      });
    }
  